import type { DemoRoster, DemoSlot } from '../api/demoRoster.js';

export function isRosterAvailable(roster: DemoRoster | undefined): boolean {
  return roster?.availability.type === 'available';
}

/**
 * Whether this clinician owns any demo copy to browse. An available roster
 * lists every fixture, with `absent` for the ones not yet claimed, so a slot
 * alone is not ownership. Off sandbox the roster is unavailable with no slots,
 * so this is false everywhere else by construction rather than by a second
 * environment check.
 */
export function ownsDemoCopies(roster: DemoRoster | undefined): boolean {
  return (
    isRosterAvailable(roster) &&
    (roster?.slots.some((slot) => slot.state.type !== 'absent') ?? false)
  );
}

export function isAnySlotSeeding(roster: DemoRoster | undefined): boolean {
  return roster?.slots.some((slot) => slot.state.type === 'seeding') ?? false;
}

export function hasSlotFinishedSeeding(
  previous: DemoRoster | undefined,
  next: DemoRoster
): boolean {
  return next.slots.some(
    (slot) => slot.state.type === 'ready' && findSlot(previous, slot.slug)?.state.type === 'seeding'
  );
}

export function countReadySlots(roster: DemoRoster): number {
  return roster.slots.filter((slot) => slot.state.type === 'ready').length;
}

export function findReadySlotForPatient(
  roster: DemoRoster | undefined,
  patientUserId: string
): DemoSlot | undefined {
  return roster?.slots.find(
    (slot) => slot.state.type === 'ready' && slot.state.patient_user_id === patientUserId
  );
}

export function findSlot(roster: DemoRoster | undefined, slug: string): DemoSlot | undefined {
  return roster?.slots.find((slot) => slot.slug === slug);
}
